import type { FormType } from '../../types/form-type';
import type { NoResults } from './no-results';

export function ContactFormType(this: NoResults): FormType {
  switch (this.reason()) {
    case 'general':
      return 'generalInquiry';
    case 'map':
      return 'propertyPreview';
    case 'model':
      return 'unavailableModels';
    case 'rep':
      return 'emptyRepListings';
  }
}
